import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { taskManagementTargetSelector } from "./taskManagementTargetSelector";

export const taskManagementTargetExistingTasksTargetIdsSelector =
  createDraftSafeSelector([taskManagementTargetSelector], (target) =>
    Object.keys(target?.existingTasks ?? {}),
  );
